import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CustomButton, CustomInput } from "../../../../components";
import AddIcon from "../../icons/AddIcon";
import MinusIcon from "../../icons/MinusIcon";
import styles from "./style.module.scss";

export type paramsType = {
  label?: any;
  name?: string;
  onChange?: any;
  onClick?: any;
  disabled?: boolean;
  rules?: any;
  suffix?: any;
  defaultValue?: any;
  hasPromote?: boolean;
  loading?: boolean;
  placeholder?: any;
};

const Collapse: React.FC<paramsType> = ({
  name,
  label,
  onChange,
  disabled,
  onClick,
  rules,
  suffix,
  loading,
  defaultValue,
  hasPromote,
  placeholder,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [collapse, setCollapse] = useState(hasPromote);

  return (
    <>
      {collapse ? (
        <div className={styles.promo} onClick={() => setCollapse(false)}>
          <MinusIcon color="var(--grey400)" />
          {label}
        </div>
      ) : (
        <div className={styles.promo} onClick={() => setCollapse(true)}>
          <AddIcon color="var(--primary500)" />
          {label}
        </div>
      )}
      {collapse ? (
        <div className={styles.confirmBtn}>
          <CustomInput
            formItemProps={{
              name: name,
              rules: rules,
            }}
            inputProps={{
              onChange: onChange,
              placeholder: placeholder,
              suffix: suffix,
              defaultValue: defaultValue,
            }}
          />

          <CustomButton
            type="primary"
            disabled={disabled}
            onClick={onClick}
            loading={loading}
          >
            {t("normal.confirm")}
          </CustomButton>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default Collapse;
